import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { AbstractComponent } from 'lib-trend-core'

interface IntegrationCard {
  key: string;
  title: string;
  subtitle: string;
  route: string[];
  iconSrc: string;
  visible: () => boolean;
}

@Component({
    selector: 'integrations-component',
    templateUrl: 'integrations.v2.component.html',
    // templateUrl: 'integrations.component.html',
    styleUrl: 'integrations.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationsComponent extends AbstractComponent implements OnInit {
  cards: IntegrationCard[] = [
    {
      key: 'webhook',
      title: 'Webhook',
      subtitle: 'Gerenciar Webhooks',
      route: ['webhook/list'],
      iconSrc: '../../../assets/images/v2/svg/icon-webhook.svg',
      visible: () => this.getModuleWebhook(),
    },
    // {
    //   key: 'openai',
    //   title: 'OpenAI',
    //   subtitle: 'Integração OpenAI',
    //   route: ['openai/list'],
    //   iconSrc: '../../../assets/images/v2/svg/icon-openai.svg',
    //   visible: () => this.getModuleOpenAI(),
    // },
    // {
    //   key: 'trendgpt',
    //   title: 'TrendGPT',
    //   subtitle: 'Assistentes e Fluxos',
    //   route: ['trendgpt/list'],
    //   iconSrc: '../../../assets/images/v2/svg/icon-openai.svg',
    //   visible: () => this.getModuleTrendGPT(),
    // },
    {
      key: 'pipedrive',
      title: 'Pipedrive',
      subtitle: 'Sincronizar CRM',
      route: ['pipedrive/list'],
      iconSrc: '../../../assets/images/logopipedrive.svg',
      visible: () => this.getModulePipedrive(),
    },
    {
      key: 'agendor',
      title: 'Agendor',
      subtitle: 'Integração Agendor',
      route: ['agendor/list'],
      iconSrc: '../../../assets/images/agendor.svg',
      visible: () => this.getModuleAgendor() && this.env !== 'prod',
    },
    {
      key: 'santri',
      title: 'Santri',
      subtitle: 'Webhooks Santri',
      route: ['santri/list'],
      iconSrc: '../../../assets/images/v2/svg/icon-openai.svg',
      visible: () => this.getModuleWebhookSantri(),
    },
  ];

  ngOnInit(): void { }
}
